<template v-show="group">
  <div v-if="loadingStatus" class="text-center loading-wrapper">
    <div class="loading-container">
      <template>
        <v-sheet class="py-2">
          <v-skeleton-loader class="mx-auto mb-5 skeleton__title" type="text" tile="tile"></v-skeleton-loader>
          <v-skeleton-loader class="mx-auto" type="list-item@8" tile="tile"></v-skeleton-loader>
        </v-sheet>
      </template>
    </div>
  </div>

  <div v-else class="regioni-btns__container">
    <v-row>
      <v-col class="mb-5">
        <h1 v-if="this.table === 'categorie'" class="text-center">Scegli la regione</h1>
        <h1 v-else-if="this.table === 'regioni'" class="text-center">Scegli la tipologia</h1>
        <h1 v-else-if="this.table === 'vitigni'" class="text-center">Scegli la regione</h1>
        <h1 v-else class="text-center">Seleziona</h1>
      </v-col>
    </v-row>

    <div class="wine-regs d-flex flex-column mx-sm-15 mt-5">
      <div class="wine-cat" v-for="item in group" :key="item">
        <v-btn v-if="item != 'undefined'" block v-on:click="goSubList(categoria, table, item)" outlined large class="btn-neu">{{ item }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'Vini',
  props: ['table', 'categoria'],
  data() {
    return {};
  },
  components: {},
  methods: {
    goSubList: function (cat, tab, sub) {
      this.$router.push({ name: 'vinisublist', params: { categoria: cat, table: tab, sublist: sub } });
    }
  },
  computed: {
    group() {
      let wines;

      if (this.$route.params.table === 'categorie') {
        let filtered = this.$store.state.data.filter((obj) => obj.fields.Categoria === this.$route.params.categoria);

        let regions = _.groupBy(filtered, 'fields.Regione');

        wines = Object.keys(regions).sort();
      } else if (this.$route.params.table === 'regioni') {
        const filtered = this.$store.state.data.filter((obj) => obj.fields.Regione === this.$route.params.categoria);

        let categories = _.groupBy(filtered, 'fields.Categoria');

        wines = Object.keys(categories).sort();
      } else if (this.$route.params.table === 'vitigni') {
        const filtered = this.$store.state.data.filter((obj) => {
          if (obj.fields.Vitigno) {
            return obj.fields.Vitigno.includes(this.$route.params.categoria);
          }
        });

        let regions = _.groupBy(filtered, 'fields.Regione');

        wines = Object.keys(regions).sort();
      }

      return wines;
    },
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    }
  }
};
</script>
